import React, { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { notify } from '../toast';
import { useNavigate } from 'react-router-dom';

const EmployeeDashboard = ({ user, role }) => {

  const now = new Date();

  const [activeIndex, setActiveIndex] = useState(0);
  const [holders, setHolders] = useState([]);
  const [totalHolders, setTotalHolders] = useState(1);
  const [directSubordinates, setDirectSubordinates] = useState([]);
  const [totalDirectSubordinates, setTotalDirectSubordinates] = useState(1);
  const [record, setRecord] = useState({});

  const [pageLoading, setPageLoading] = useState(false);
  const [incentiveLoading, setIncentiveLoading] = useState(false);

  const [filter, setFilter] = useState('');
  const [filteredHolders, setFilteredHolders] = useState([]);
  const [filteredSubordinates, setFilteredSubordinates] = useState([]);

  const [cards, setCards] = useState([{ title: "Holders", value: 0 }]);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const fetchEmployeeDashboard = async () => {
    try {

      setPageLoading(true);

      const response = await axiosPrivate.get(`/employee/getDashboard?page=${Math.max(
        Math.ceil(holders.length / 10) + 1,
        Math.ceil(directSubordinates.length / 10) + 1
      )}`);

      const data = response?.data
      setHolders(prev => [...prev, ...data?.holders]);
      setTotalHolders(data?.totalHolders);

      setDirectSubordinates(prev => [...prev, ...data?.directSubordinates]);
      setTotalDirectSubordinates(data?.totalDirectSubordinates);

      if (role !== "village_cluster") {
        setCards([
          { title: "Holders", value: data?.totalHolders },
          { title: "Direct subordinates", value: data?.totalDirectSubordinates }
        ]);
      } else {
        setCards([
          { title: "Holders", value: data?.totalHolders },
        ]);
      }

    } catch (err) {
      notify('failed', err?.response?.data?.message);
    } finally {
      setPageLoading(false);
    }
  }

  const fetchTodayIncentive = async (forceRefresh = false) => {

    try {
      const todayIncentive = sessionStorage.getItem('todayIncentive');
      if (!forceRefresh && todayIncentive !== null) {
        return setRecord(JSON.parse(todayIncentive));
      }

      setIncentiveLoading(true);

      const response = await axiosPrivate.get('/employee/getTodayIncentive');

      const data = response?.data;
      setRecord(data);
      sessionStorage.setItem('todayIncentive', JSON.stringify(data));

    } catch (err) {
      notify('failed', err?.response?.data?.message);
    } finally {
      setIncentiveLoading(false);
    }
  }

  useEffect(() => {
    setCards(prev => (role !== "village_cluster" ?
      [...prev, { title: "Direct subordinates", value: 0 }] : prev));

    fetchEmployeeDashboard();
    fetchTodayIncentive();

    // eslint-disable-next-line
  }, []);

  const fetchFilteredHolders = async () => {
    if (!filter) {
      return clearFilter();
    }

    try {
      const result = await axiosPrivate.get(`/employee/getFilteredHolders?filter=${filter}`);
      setFilteredHolders(result?.data);

    } catch (err) {
      notify('failed', err?.response?.data?.message);
      clearFilter();
    }
  };

  const fetchFilteredSubordinates = async () => {
    if (!filter) {
      return clearFilter();
    }

    try {
      const result = await axiosPrivate.get(`/employee/getFilteredSubordinates?filter=${filter}`);
      setFilteredSubordinates(result?.data);

    } catch (err) {
      notify('failed', err?.response?.data?.message);
      clearFilter();
    }
  };

  const clearFilter = () => {
    setFilter('');
    setFilteredHolders([]);
    setFilteredSubordinates([]);
  }

  return (

    <div className="container">
      <div className="dashboard">
        <div className="inner">

          <h2>Welcome back, <i style={{ color: 'var(--secondary-text-color)' }}>{user}</i></h2>

          <div className="cards-container">

            {cards.map((card, index) => (
              <div
                key={index}
                className={`card ${activeIndex === index ? "active" : ""}`}
                onClick={() => {
                  setActiveIndex(index);
                  clearFilter();
                }}
              >
                <div className="card-body">
                  <h3 className="card-title">{card.title}</h3>
                  <h3 className="card-value">{card.value}</h3>
                </div>
              </div>
            ))}

            <div className='card'>
              <div className="card-body">
                <h3 className="card-title">{now.getDate() < 16 ? 'Monthly pre mid' : 'Monthly post mid'} direct incentive</h3>
                <h3 className="card-value">{record?.directRegistrationIncentive || 0}</h3>
              </div>
            </div>

            {role !== "village_cluster" !== 0 &&
              <div className='card'>
                <div className="card-body">
                  <h3 className="card-title">{now.getDate() < 16 ? 'Monthly pre mid' : 'Monthly post mid'} referral incentive</h3>
                  <h3 className="card-value">{record?.referralIncentive || 0}</h3>
                </div>
              </div>
            }

          </div>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <button className='approve-btn' disabled={incentiveLoading} onClick={() => fetchTodayIncentive(true)}>{incentiveLoading ? <span className='spinner' /> : 'Load Incentive'}</button>
          </div>

        </div>
      </div>

      <div className='formRow'>
        <div className='formGroup'>
          <input
            className='formInput'
            type="text"
            placeholder='Filter'
            value={filter}
            onChange={(event) => setFilter(event.target.value)}
          />
        </div>
        <div className='formGroup'>
          <button className="add-btn" onClick={activeIndex === 0 ? fetchFilteredHolders : fetchFilteredSubordinates}>Search</button> &nbsp;
          <button className="close-btn" style={{ borderRadius: '10rem' }} onClick={clearFilter}>Clear filter</button>
        </div>
      </div>

      {// @ts-ignore
        activeIndex === 0 && holders?.length !== 0 &&

        <>
          <section className="user-list">
            <div className="list-header">
              <span>Name</span>
              <span>Mobile</span>
              <span>Member count</span>
              <span>Action</span>
            </div>

            <div className="list-body">
              {// @ts-ignore
                (filteredHolders.length !== 0 ? filteredHolders : holders).map((holder) => (
                  <div
                    className="list-row employee-row"
                    key={holder?._id}
                    onClick={() => navigate(`/holderEdit/${holder?._id}`)}>
                    <span className='truncate' title={holder?.name} data-label="Name">{holder?.name}</span>
                    <span className='truncate' title={holder?.mobile} data-label="Mobile">{holder?.mobile}</span>
                    <span className='truncate' title={holder?.members?.length} data-label="Member count">{holder?.members?.length || 0}</span>
                    <span>
                      <button
                        className="approve-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/holderCard/${holder?._id}`);
                        }}>View Card</button>
                    </span>
                  </div>
                ))
              }
            </div>

          </section>

          {(totalHolders !== holders.length) && (filteredHolders.length === 0) ?
            <div>
              <button className='add-btn' disabled={pageLoading} onClick={fetchEmployeeDashboard}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
            </div>
            : <></>
          }
          <br />

        </>
      }

      {// @ts-ignore
        role !== "village_cluster" && activeIndex === 1 && directSubordinates?.length !== 0 &&

        <>
          <section className="user-list">
            <div className="list-header">
              <span>Id</span>
              <span>Name</span>
              <span>Gender</span>
              <span>Mobile</span>
              <span>Email</span>
              <span>Action</span>
            </div>

            <div className="list-body">
              {// @ts-ignore
                (filteredSubordinates.length !== 0 ? filteredSubordinates : directSubordinates).map((subordinate) => (
                  <div className="list-row employee-row"
                    key={subordinate?._id}
                    onClick={() => navigate(`/employee/${subordinate?._id}`, {
                      state: {
                        name: subordinate?.name
                      }
                    })}
                  >
                    <span className='truncate' title={subordinate?.employeeId} data-label="ID">{subordinate?.employeeId}</span>
                    <span className='truncate' title={subordinate?.name} data-label="Name">{subordinate?.name}</span>
                    <span className='truncate' title={subordinate?.gender} data-label="Gender">{subordinate?.gender}</span>
                    <span className='truncate' title={subordinate?.mobile} data-label="Mobile">{subordinate?.mobile}</span>
                    <span className='truncate' title={subordinate?.email} data-label="Email">{subordinate?.email}</span>
                    <span>
                      <button
                        className="approve-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/employeeCard/${subordinate?._id}`)
                        }}>
                        View Card
                      </button>
                    </span>
                  </div>
                ))
              }
            </div>

          </section>

          {(totalDirectSubordinates !== directSubordinates.length) && (filteredSubordinates.length === 0) ?
            <div>
              <button className='add-btn' disabled={pageLoading} onClick={fetchEmployeeDashboard}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
            </div>
            : <></>
          }
          <br />

        </>
      }

    </div>
  )
}

export default EmployeeDashboard
